import { render } from "./ActionAppointment.vue?vue&type=template&id=15c8e096&scoped=true"
import script from "./ActionAppointment.vue?vue&type=script&lang=js"
export * from "./ActionAppointment.vue?vue&type=script&lang=js"

import "./ActionAppointment.vue?vue&type=style&index=0&id=15c8e096&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c8e096"]])

export default __exports__